import { AuthenticationWrapper } from './AuthenticationWrapper';

export const authenticationWrapper = AuthenticationWrapper.getInstance();

